import { useConfig } from "../../../contexts/useConfig";
import { useTranslation } from 'react-i18next';


import LinkIcon from "../../../assets/icons/New-Page.png";
import ActionButtonStandard from "../Action/ActionButtonStandard";
import {getPropertyOrDefault} from "../../../helpers/helpers";


export default function LinkButton() {
   const [config] = useConfig();
   const {t} = useTranslation();
      const showActionIcons = getPropertyOrDefault(config["show-action-icons"], true);
      const buttonUrl = getPropertyOrDefault(config["linkButtonUrl"], "https://reydar.com");
   
   
    const handleClick = () => {
        window.open(buttonUrl, "_")
    }


   return config.actions.link && 
   <ActionButtonStandard
   label={config?.customActionNames?.link ?? t('linkButtonName')}
   className={showActionIcons ? "" : "noIcons"}
   iconImg={LinkIcon}
   handleClick={handleClick} />;
}
